import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GfrGridComponent } from './components/gfr-grid/gfr-grid.component';
import { BentoModule } from '@bento/bento-ng';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { WjGridGrouppanelModule } from '@grapecity/wijmo.angular2.grid.grouppanel';
import { FormsModule } from '@angular/forms';
import { ContextMenuModule } from 'ngx-contextmenu';
import { ControlSheetComponent } from './components/control-sheet/control-sheet.component';
import { RouteWorkflowComponent } from './components/route-workflow/route-workflow.component';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MyNgbDateParserFormatter } from './myNgbDateParserFormatter';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [GfrGridComponent, ControlSheetComponent, RouteWorkflowComponent],
  imports: [
    CommonModule,
    WjInputModule,
    WjGridModule,
    WjGridFilterModule,
    WjGridGrouppanelModule,
    FormsModule,
    BentoModule,
    NgbModule,
    ReactiveFormsModule,
    ContextMenuModule.forRoot({
      useBootstrap4: true,
    }, )
  ],
  exports: [
    GfrGridComponent, 
    ControlSheetComponent, 
    RouteWorkflowComponent
  ],
 // exports: [GfrGridComponent],
  providers: [{provide: NgbDateParserFormatter, useFactory: () => new MyNgbDateParserFormatter(localStorage.getItem('userPrefDateFormat') === null ? 'MM-dd-yyyy' : localStorage.getItem('userPrefDateFormat'))}]
})
export class SharedModule { }
